import React from "react";
import { Box } from '@mui/joy';

const FleetManagerIframe = ({ }) => {
    const url = window.location.href;
    const parts = new URL(url).hostname.split(".");
    const thirdLevel = parts.length > 2 ? parts.slice(0, -2).join(".") : 'demo';
    const iframeurl = 'https://fleetservices.myfleetsolution.it/'+thirdLevel+'/kpis'

    return (
        <Box className="dashboard-menu dashboard-menu-1col" sx={{ aspectRatio: '4/3', width:"100%"}} data-src={thirdLevel}>
            <iframe style={{width:"100%", aspectRatio: '4/3',  border:'1px solid var(--app-surface-subdued)',borderRadius:'10px',boxShadow:'0 0 50px rgba(0,0,0,0.12)', overflow:'hidden', display: "block"}} src={iframeurl} scrolling="no"></iframe>
        </Box>
    )
}

export default FleetManagerIframe;